import { transactionService } from '../services'

export default (formData) => {
	return new Promise(resolve => {
		transactionService.uploadValoresParamRule(formData)
			.then(response => resolve(response.data))
	})
}
